const minutesToMilliseconds = (minutes = 0) => minutes * 60000;

export default minutesToMilliseconds;
